import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'Features', path: '/features' },
    { label: 'Contact', path: '/contact' },
    { label: 'Join Now', path: '/join' },
  ];

  const isActive = (path: string) => location.pathname === path;

  const hasLightBg = scrolled || !isHome;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        hasLightBg ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/assets/images/loadapi-logo.png"
            alt="LoadAPI.io"
            className="h-9 w-auto"
          />
          <span className={`text-xl font-bold transition-colors ${hasLightBg ? 'text-zinc-900' : 'text-white'}`}>
            LoadAPI.io
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors ${
                isActive(link.path)
                  ? 'text-blue-600'
                  : hasLightBg
                  ? 'text-zinc-600 hover:text-zinc-900'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/join"
            className="px-5 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            Get Started
          </Link>
        </div>

        <button
          className="md:hidden p-2 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <div className={`w-6 h-6 flex items-center justify-center ${hasLightBg ? 'text-zinc-900' : 'text-white'}`}>
            <i className="ri-menu-3-line text-2xl"></i>
          </div>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-zinc-100 px-6 py-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 text-sm font-medium ${
                isActive(link.path) ? 'text-blue-600' : 'text-zinc-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/join"
            className="block mt-3 px-5 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-full text-center whitespace-nowrap"
          >
            Get Started
          </Link>
        </div>
      )}
    </nav>
  );
}
